import { createAction } from 'redux-actions'

export const clearSchool = createAction('CLEAR_SCHOOL')
